import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "./components/Router";
import { Auth } from "redux-server-connection";
import { connect } from "react-redux";

import config from "./config";
import Render from "./Render";

Auth.setEndpoints({
  login: `${config.api.baseUrl}/api/v1/auth`,
  logout: `${config.api.baseUrl}/api/v1/auth/logout`,
  me: `${config.api.baseUrl}/api/v1/users/me`
});

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static childContextTypes = {
    config: PropTypes.object
  };

  render() {
    return <Render {...this.state} {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {
    isLoading: Object.keys(state).reduce((prev, reducer) => {
      return (
        prev ||
        Object.values(state[reducer].isFetching).reduce(
          (prev, url) => prev || url,
          false
        )
      );
    }, false)
  };
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js